import { SectionHeader } from '../common/section-header'
export function GuidelineLevelLists({
  title,
  rows,
  itemKey,
}: {
  title: string
  rows: Array<{ levelRange: string; sections?: string[]; missions?: string[] }>
  itemKey: 'sections' | 'missions'
}): JSX.Element {
  return (
    <div>
      <SectionHeader level={3} title={title} />
      <div className="mt-2 space-y-3">
        {rows.map((row) => (
          <div key={row.levelRange}>
            <h4 className="text-label font-semibold uppercase tracking-wide text-text-secondary">
              {row.levelRange}
            </h4>
            <ul className="mt-1 list-disc space-y-1 pl-5 text-body text-text-secondary">
              {(row[itemKey] ?? []).map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export function GuidelineList({
  title,
  items,
  priority = false,
}: {
  title: string
  items: string[]
  priority?: boolean
}): JSX.Element {
  return (
    <div
      className={priority ? 'rounded-token-card border border-accent bg-surface-app p-4' : ''}
    >
      <SectionHeader level={3} title={title} />
      <ul className="mt-2 list-disc space-y-1 pl-5 text-body text-text-secondary">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  )
}
